import React, { useEffect, useCallback } from 'react';
import { foreignTradeInput, foreignTradeEUInput } from '../data/searchFlowText';
import { useSelector } from 'react-redux';
import Navigation from '../components/navigation/navigation';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';

import RadioInput from '../components/searchInputs/radioInput';

const ForeignTrade = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);

	const handleNext = useCallback(
		(inc) => {
			props.handleNext(inc);
		},
		[props]
	);
	const handleBack = useCallback(
		(decr) => {
			props.handleBack();
		},
		[props]
	);

	// Validation logic: if foreign_trade is true, foreigntradeEU must be selected
	const isNextDisabled =
		companyStore.foreign_trade === true && !companyStore.foreigntradeEU;

	useEffect(() => {
		function handleKeyDown(e) {
			if (e.keyCode === 13 && !isNextDisabled) {
				handleNext();
			}
		}
		document.addEventListener('keydown', handleKeyDown);

		// Don't forget to clean up
		return function cleanup() {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [props, handleNext, isNextDisabled]);

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">
						{i18n.t('searchflow.sfspecialinfotext3')}
					</span>{' '}
					<span className="questionTracker">1/5</span>
				</p>
				<RadioInput storeID="foreign_trade" dataText={foreignTradeInput()} />
				{companyStore.foreign_trade === true && (
					<>
						<hr />
						<span className="SFSubTitle">
							{i18n.t('searchflow.sfspecialinfotext4')}
						</span>
						<RadioInput
							storeID="foreigntradeEU"
							dataText={foreignTradeEUInput()}
						/>
					</>
				)}
			</div>
			<Navigation
				step={7}
				handleBack={() => handleBack()}
				handleNext={() => handleNext()}
				openHelpForm={() => props.openHelpForm()}
				disabledProp={isNextDisabled}
			/>
		</div>
	);
};

export default withTranslation()(ForeignTrade);
